import moment from "moment";
export class StaffProbationDtl {
  StaffID;
  DateInt;
  Grp;
  Item;
  Ans;
  constructor() {
    this.StaffID = "";
    this.DateInt = moment().format("YYYY-MM-DD");
    this.Grp = "";
    this.Item = "";
    this.Ans = "";
  }
}



// WEBPACK FOOTER //
// ./src/model/StaffProbationDtl.js